import { get } from '@/plugins/http'

export default {
  getIsBindAlpha: get('/live/api/v1/user/isAlpha'),
  getBannerData: get('/live/api/v1/home/bannerStatistics'),
  getPromoteFilters: get('/live/api/v1/recordCourse/category/list?liveShow=false'),
  getPromoteList: get('/live/api/v1/recordCourse/auth/mobile/list'),
  getPromoteBanner: get('/live/api/v1/record/totalPvUv'),
  getExpandFilter: get('/live/api/v1/marketExpansionType/list'),
  getTemplateFilter: get('/live/api/v1/marketExpansionSubjectType/list?needShow=1'),
  getExpandList: get('/live/api/v1/marketExpansion/web'),
  getExpandBanner: get('/live/api/v1/marketExpansion/totalDownload'),
  downloadExpand: (id) => get(`/live/api/v1/courses/${id}/download`),
  globalSearch: (query) => get(`/live/api/v1/home/search?query=${query}`),
  getExpandCourseware: (id) => get(`/live/api/v1/marketExpansion/detail?id=${id}`),
}
